<div class="badge-wrapper">
  <div ui-badge [badge]="context" ui-badgeSize="medium" ui-badgePosition="above after" badgeRoundBackground></div>
  <ng-content />
</div>
